<template>
  <div class="news-center">
    <div class="content">
      <h2>新闻中心</h2>
      <ul class="news-type">
        <li :class="{ selected: -1 == actIndex }" @touchend="newsType()">
          全部
        </li>
        <li
          v-for="(item, index) in type"
          :key="index"
          :class="{ selected: item.id == actIndex }"
          @touchend="newsType(item.name, item.id)"
        >
          {{ item.name }}
        </li>
        <li :class="{ selected: -2 == actIndex }" @touchstart="teamType">
          <!-- 团队风采 -->
        </li>
      </ul>
      <div class="news-swiper-container" ref="newsPages">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide swiper-no-swiping"
            v-for="(page, index) in pages"
            :key="index"
          >
            <ul class="news-list">
              <li
                @touchstart="highlight(item * 4 + index2)"
                @touchend="recover(item * 4 + index2)"
                v-for="(item, index2) in page"
                :key="item.id"
              >
                <img :src="item.image" alt="" />
                <h4>{{ item.title }}</h4>
                <span>{{ item.createtime }}</span>
                <!-- <p v-html="page[index].content"></p> -->
                <div @touchstart="newsDetail(item.id)">
                  查看详情
                  <i class="iconfont icon-yousanjiaoxing"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="swiper-tool">
        <i class="news-swiper-button-prev iconfont icon-jiantouzuo"></i
        ><i class="news-swiper-button-next iconfont icon-icon_arrow_right"></i>
        <div class="news-swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "NewsCenter",
  props: {
    type: Array,
    news: Array,
    teamList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      url: "",
      actIndex: -1,
      newsData: [],
      newsArr: {},
      netNewsData: [],
      netNewsArr: {},
      isClick: true,
    };
  },
  created() {
    this.url = this.$imgUrl;
    // {
    //   {
    //     console.log(this.url);
    //   }
    // }

    this.getNewsList();
    // console.log(this.pages)
  },
  mounted() {
    // console.log(this.url, "12312", this.$imgUrl);
  },
  methods: {
    getNewsList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/news",
        { limit: 10, page: this.page, type_id: this.type_id },
        (res) => {
          if (res.code == 1) {
            // console.log(res.data);
            this.netNewsArr = res.data;
            this.netNewsData = res.data.data;
            // console.log(this.netNewsArr)
          }
        }
      );
    },
    teamType() {
      this.actIndex = -2;
      this.newsData = this.teamList;
    },
    newsType(type, index) {
      if (type == null) {
        this.newsData = this.newsArr.all;
        this.actIndex = -1;
      } else {
        this.newsData = this.newsArr[type];
        this.actIndex = index;
      }
    },
    newsTypeArr() {
      for (var i = 0; i < this.news.length; i++) {
        var type = this.news[i].type;
        if (!this.newsArr[type]) {
          this.newsArr[type] = [];
        }
        this.newsArr[type].push(this.news[i]);
      }
      this.newsArr.all = this.news;
    },
    highlight(id) {
      this.$refs.newsPages
        .getElementsByTagName("li")
        [id].getElementsByTagName("div")[0].className = "highlight";
    },
    recover(id) {
      this.$refs.newsPages
        .getElementsByTagName("li")
        [id].getElementsByTagName("div")[0].className = "";
    },
    imgSwiper() {
      var swiper = new Swiper(".news-swiper-container", {
        slidesPerView: 1,
        noSwiping: true,
        navigation: {
          nextEl: ".news-swiper-button-next",
          prevEl: ".news-swiper-button-prev",
        },
        pagination: {
          el: ".news-swiper-pagination",
          type: "fraction",
        },
        autoHeight: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, //修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: function (swiper) {
          swiper.update();
          mySwiper.startAutoplay();
          mySwiper.reLoop();
        },
      });
    },
    getDate(time) {
      var date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      // console.log(date);
      return Y + M + D;
    },
    newsDetail(id) {
      if (this.actIndex == -2) {
        this.$router.push("/m_newsdetail/" + id + "t");
      } else {
        this.$router.push("/m_newsdetail/" + id);
      }
    },
  },
  computed: {
    pages() {
      if (!this.netNewsData) return;
      const pages = [];
      this.netNewsData.forEach((item, index) => {
        const page = Math.floor(index / 4);
        if (!pages[page]) pages[page] = [];
        pages[page].push(item);
      });
      return pages;
    },
  },
  watch: {
    news(newVal) {
      // console.log(newVal)
      this.newsData = newVal;
      this.newsTypeArr();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/mixins.styl';
@import '~styles/varible.styl';

.news-center >>> .swiper-button-disabled {
  color: #999 !important;
}

.news-center >>> .news-swiper-pagination {
  color: #999 !important;
}

.news-center >>> .swiper-pagination-current {
  color: #282828;
}

.news-list >>> p {
  * {
    text-indent: 0 !important;
    line-height: 1.4em !important;
    font-size: 16px !important;
  }
}

.news-center {
  background: #f6f6f6;

  .content {
    padding: 0.76rem 4% 1.26rem;
    text-align: center;

    h2 {
      color: #333;
      font-size: 0.4rem;
      font-weight: 800;
      margin-bottom: 0.4rem;
      letter-spacing: 1px;
    }

    .news-type {
      width: 100%;

      li {
        float: left;
        width: 18.8%;
        margin-right: 1.5%;
        margin-bottom: 1.5%;
        background: #ddd;
        color: #333;
        font-size: 0.26rem;
        line-height: 2.8em;
        border-radius: 0.04rem;
      }

      li:nth-of-type(5n) {
        margin-right: 0;
      }

      li.selected {
        background: $black;
        color: #fff;
      }
    }

    .news-swiper-container {
      width: 100%;
      overflow: hidden;
      text-align: left;

      .news-list {
        width: 100%;

        li {
          padding: 5% 6% 8%;
          background: #fff;
          margin-top: 6%;
          overflow: hidden;

          img {
            width: 100%;
            vertical-align: middle;
            margin-bottom: 0.46rem;
            height: 4.5rem;
          }

          h4 {
            color: #333;
            font-size: 0.3rem;
            margin-bottom: 0.4rem;
            line-height: 1.4em;
          }

          span {
            color: #999;
            font-size: 0.26rem;
          }

          >p {
            font-size: 0.3rem;
            color: #666;
            line-height: 1.4em;
            text-ellipsis();
            height: 2.8em;
            margin-top: 0.44rem;

            p {
              font-size: 0.3rem !important;
              line-height: 1.6em !important;
            }

            span {
              font-size: 0.3rem !important;
              line-height: 1.6em !important;
            }
          }

          >div {
            display: inline-block;
            margin-left: 0.52rem;
            padding: 0.06rem 0.4rem;
            color: #666;
            font-size: 0.24rem;
            line-height: 2em;
            text-align: center;
            border: 1px solid #4a4a4a;
            border-radius: 2em;

            i {
              margin-left: 0.18rem;
              font-size: 0.24rem;
              color: #2c2c2c;
            }
          }

          .highlight {
            background: $yellow;
            color: #fff;
            border: 1px solid $yellow;
          }
        }
      }
    }

    .swiper-tool {
      margin-top: 0.4rem;
      font-size: 0.28rem;

      i {
        display: inline-block;
        padding: 0 6%;
        line-height: 3em;
        background: #0d0d0d;
        color: #fff;
        font-size: 0.28rem;
      }

      >div {
        margin-top: 0.16rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/NewsCenter.vue